import { useRouteInfoForCurrentPath } from 'app/shared/utils/useRouteInfoForCurrentPath';

export const useFeatureFlagsForCurrentPath = () => {
  const routeInfo = useRouteInfoForCurrentPath();

  return routeInfo?.featureFlagsToLoad || [];
};
